"use client";

import { BannerSection } from "@/components/sections/BannerSection";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { FormkitSad } from "@/assets/icons/formkit-sad";
import { useTranslations } from "next-intl";

export default function NotFound() {
  const t = useTranslations("notFound");

  return (
    <main className="min-h-[50vh]">
      <BannerSection title={t("title")} />
      <section className="flex flex-col items-center justify-center bg-background py-24">
        <div className="px-4 py-16 ph:px-24 md:px-48 lg:px-72 xl:px-96">
          <div className="flex flex-col items-center gap-8">
            <FormkitSad className="h-12 w-12 text-primary" />

            <p className="text-md text-center font-extralight text-white/80">
              {t("description")}
            </p>

            <div className="mt-8">
              <PrimaryButton
                text={t("backToHome")}
                navigateTo="/"
                variant="primary"
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
